document.addEventListener('DOMContentLoaded', function() {
     // Get all the buttons
     const buttons = document.querySelectorAll('.question__question');

     buttons.forEach((item, index) => {
          item.addEventListener('click', function() {
               const questionDiv = this.closest('.question');
               questionDiv.classList.toggle('question--active');
          });
     });
});